import { render, staticRenderFns } from "./MailHistory.vue?vue&type=template&id=8d577002&"
import script from "./MailHistory.vue?vue&type=script&lang=js&"
export * from "./MailHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports